<template>
  <div class="vue-logo" style="height: 65px">
    <template>
      <span class="vue-logo_title" key="1">
        <div v-if="wxUserId == '2043870969731301377'">
          <!-- <img
            src="@/page/login/images/1.png"
            alt="logo"
            class="logo-image"
            style=""
          /> -->
          枫和康达（杭州）科技有限公司
        </div>
        <div v-else>
          <img
            src="@/page/login/images/1.png"
            alt="logo"
            class="logo-image"
            style=""
          />
          大白数智家医科技
        </div>
      </span>
    </template>
  </div>
</template>

<script>
import { title } from "@/config";

export default {
  name: "Logo",
  data() {
    return {
      title: title,
      wxUserId: window.localStorage.getItem('pcUserId')
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active {
  transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.vue-logo {

  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 64px;
  line-height: 64px;
  background-color: #20222a;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;

    background-color: #fff;
    color: black;

  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 16px;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      .logo-image {
        width: 40px; /* 调整图片宽度 */
        height: 40px; /* 调整图片高度 */
        margin-right: 15px; /* 图片与文字间距 */
        border-radius: 10px;
      }
    }
  }

  &_subtitle {
    padding-top: 10px;
    display: block;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
